const getRoot = state => state.existingAccounts;
export const getExistingAccountsRequested = state => getRoot(state).requested;
export const getExistingAccountsFetched = state => getRoot(state).fetched;
export const getExistingAccountsFetching = state => getExistingAccountsRequested(state) && !getExistingAccountsFetched(state);
export const getExistingAccountsError = state => getRoot(state).fetchError;
export const getExistingAccounts = state => getRoot(state).accounts;
export const isHubless = state => getExistingAccountsFetched(state) && getExistingAccounts(state).length === 0;